module.exports = __webpack_public_path__ + "static/media/adesivo_coi.f9efcba3.png";